import { render, staticRenderFns } from "./Xuexi.vue?vue&type=template&id=4c5c2707"
import script from "./Xuexi.vue?vue&type=script&lang=js"
export * from "./Xuexi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports